
  import { Component, Vue,Prop, Watch } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import html2canvas from 'html2canvas';
	import {imgHost} from '@/utils/config'
  @Component({  
    name: '',
    components: {
      PageFooter
    }
  })

  export default class  extends Vue {
    @Prop({default:{}}) codemsg!:any
    private imgloading = false
    private imgcode = ''
    private downimg = ''
    private msg:any = {}
    @Watch('codemsg',{deep:true})
    private getmsg(){
      this.downimg = ''
      this.msg = this.codemsg
      // console.log(this.codemsg)
      this.imgcode = this.codemsg.url
      // this.createCanvas()
    }
    private mounted () {
      this.downimg = ''
      this.msg = this.codemsg
      // console.log(this.codemsg,2)
      this.imgcode = this.codemsg.url
      
      // this.createCanvas()
    }
    private createCanvas(){
      this.$nextTick(()=>{

        html2canvas(document.getElementById('codeId'), {
          useCORS: true, // 【重要】开启跨域配置
          scale: 2,
          allowTaint: true, // 允许跨域图片
          scrollX:0,
          scrollY:0,
        }).then((canvas)=>{
          this.downimg = canvas.toDataURL('image/jpeg');
          if (this.downimg) {
            let alink = document.createElement('a')
            alink.href = this.downimg
            alink.download = this.msg.title
            alink.click()
            alink.remove()
          }
        });
      })
		}
    
  }
